/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsLocaleString,
    MelcoModelsLocaleStringFromJSON,
    MelcoModelsLocaleStringFromJSONTyped,
    MelcoModelsLocaleStringToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsLocaleString
 */
export interface MelcoModelsGenericList1MelcoModelsLocaleString {
    /**
     * 
     * @type {Array<MelcoModelsLocaleString>}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleString
     */
    list: Array<MelcoModelsLocaleString>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleString
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsLocaleString
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsLocaleStringFromJSON(json: any): MelcoModelsGenericList1MelcoModelsLocaleString {
    return MelcoModelsGenericList1MelcoModelsLocaleStringFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsLocaleStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsLocaleString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsLocaleStringFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsLocaleStringToJSON(value?: MelcoModelsGenericList1MelcoModelsLocaleString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsLocaleStringToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


